import { useState } from 'react'
import Image from 'next/image'
import styles from './kdt-design-5th.module.scss'

const InternshipTab = () => {
  const [activeTab, setActiveTab] = useState('firstTab')

  const onClickTab = (tabName: string) => {
    setActiveTab(tabName)
  }

  return (
    <>
      {/* 왼쪽 탭 메뉴 */}
      <div className="w-[395px] shrink-0 px-8 py-7">
        <ul className={`${styles.curriculum_accordion_dot_ul} flex flex-col gap-3`}>
          <li className="flex flex-row items-center gap-8">
            <div
              className={`${
                activeTab === 'firstTab'
                  ? 'border-yellow-450 bg-yellow-450 shadow-[0_0_10px_0_#FF7710]'
                  : 'border-trueGray-800 bg-white'
              } z-10 h-3 w-3 rounded-full border-[2px]`}
            ></div>
            <div
              className={`${
                activeTab === 'firstTab'
                  ? 'border-yellow-450 bg-[rgba(255,119,16,0.10)]'
                  : 'border-[#FAFAFA] bg-alternative'
              } flex-1 cursor-pointer border px-5 py-4`}
              onClick={() => onClickTab('firstTab')}
            >
              <h6
                className={`${
                  activeTab === 'firstTab' ? 'text-label-normal' : 'text-label-neutral'
                } text-xl font-bold leading-snug`}
              >
                디자인 스튜디오
                <br />
                ‘디엘스(The Else)’
                <br />
                정규직 전환형 인턴십 기회
              </h6>
            </div>
          </li>

          <li className="flex flex-row items-center gap-8">
            <div
              className={`${
                activeTab === 'secondTab'
                  ? 'border-yellow-450 bg-yellow-450 shadow-[0_0_10px_0_#FF7710]'
                  : 'border-trueGray-800 bg-white'
              } z-10 h-3 w-3 rounded-full border-[2px]`}
            ></div>
            <div
              className={`${
                activeTab === 'secondTab'
                  ? 'border-yellow-450 bg-[rgba(255,119,16,0.10)]'
                  : 'border-[#FAFAFA] bg-alternative'
              } flex-1 cursor-pointer border px-5 py-4`}
              onClick={() => onClickTab('secondTab')}
            >
              <h6
                className={`${
                  activeTab === 'secondTab' ? 'text-label-normal' : 'text-label-neutral'
                } text-xl font-bold leading-snug`}
              >
                멋쟁이사자처럼 인턴십 기회
              </h6>
            </div>
          </li>

          <li className="flex flex-row items-center gap-8">
            <div
              className={`${
                activeTab === 'thirdTab'
                  ? 'border-yellow-450 bg-yellow-450 shadow-[0_0_10px_0_#FF7710]'
                  : 'border-trueGray-800 bg-white'
              } z-10 h-3 w-3 rounded-full border-[2px]`}
            ></div>
            <div
              className={`${
                activeTab === 'thirdTab'
                  ? 'border-yellow-450 bg-[rgba(255,119,16,0.10)]'
                  : 'border-[#FAFAFA] bg-alternative'
              } flex-1 cursor-pointer border px-5 py-4`}
              onClick={() => onClickTab('thirdTab')}
            >
              <h6
                className={`${
                  activeTab === 'thirdTab' ? 'text-label-normal' : 'text-label-neutral'
                } text-xl font-bold leading-snug`}
              >
                멋사 로켓단
              </h6>
            </div>
          </li>
        </ul>
      </div>

      {/* 오른쪽 내용 영역 */}
      <div className="flex flex-1 flex-col gap-6 px-8 py-7">
        {activeTab === 'firstTab' && (
          <>
            <h6 className="text-2xl font-bold leading-snug text-label-normal">
              디자인 스튜디오 ‘디엘스(The Else)’{' '}
              <b className="text-yellow-450">정규직 전환형 인턴십</b> 기회
            </h6>

            <div className="w-full bg-alternative px-6 py-5">
              <Image
                src="https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-design-5th/section4_img1_logo_new_pc.png"
                layout="fill"
                objectFit="cover"
                className="!relative z-10 w-full object-cover"
                alt="-"
              />
            </div>

            <dl className="flex flex-col gap-3">
              <dt className="text-base font-semibold text-label-normal">기업소개</dt>
              <div className="bg-alternative px-6 py-5" role="group">
                <dd className="text-base leading-normal text-label-neutral">
                  디엘스는 디자인과 기술의 경계를 허무는 크리에이티브 웹 에이전시로, 최적의 UXUI
                  설계를 통해 <br />
                  고객의 비즈니스를 성장시키는 기업입니다.
                </dd>
                <dd className="mt-5 flex flex-col border-t pt-5">
                  <p
                    className={`${styles.text_dot} ${styles.text_dot_section4} text-base leading-normal text-label-neutral`}
                  >
                    서울시, LG CNS 등 대기업들의 프로젝트 진행
                  </p>
                  <p
                    className={`${styles.text_dot} ${styles.text_dot_section4} text-base leading-normal text-label-neutral`}
                  >
                    GDWeb, I-Web awards, Awwwards 등 국내외 웹 어워드 수상
                  </p>
                </dd>
              </div>
            </dl>
            <dl className="flex flex-col gap-3">
              <dt className="text-base font-semibold text-label-normal">채용안내</dt>
              <dd className="bg-alternative px-6 py-5 text-base leading-normal text-label-neutral">
                채용 시, 과제 전형 100% 면제!
              </dd>
            </dl>
          </>
        )}

        {activeTab === 'secondTab' && (
          <>
            <h6 className="text-2xl font-bold leading-snug text-label-normal">
              멋쟁이사자처럼 인턴십 기회
            </h6>

            <div className="w-full bg-alternative px-6 py-5">
              <p className="mb-5 text-base leading-normal text-label-neutral">
                3개월 동안 현업 프로젝트에 참여하여, 데이터 기반으로 문제를 정의하고 해결책을
                도출하는 실전 경험을 쌓습니다.
              </p>
              <div className="w-full">
                <Image
                  src="https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-design-5th/section4_img2_pc.png"
                  layout="fill"
                  objectFit="cover"
                  className="!relative z-10 w-full object-cover"
                  alt="-"
                />
              </div>
              <p className="mt-5 text-base leading-normal text-label-neutral">*실제 인턴 이미지</p>
            </div>

            <dl className="flex flex-col gap-3">
              <dt className="text-lg font-bold text-label-normal">
                현업 프로젝트에 100% 참여한 포트폴리오
              </dt>
              <div className="flex flex-row gap-6 bg-alternative px-6 py-5" role="group">
                <dd className="flex-1">
                  <Image
                    src="https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-design-5th/section4_img3_pc.gif"
                    layout="fill"
                    objectFit="cover"
                    className="!relative z-10 w-full object-cover"
                    alt="-"
                    unoptimized
                  />
                </dd>
                <dd className="flex-1">
                  <Image
                    src="https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-design-5th/section4_img4_pc.gif"
                    layout="fill"
                    objectFit="cover"
                    className="!relative z-10 w-full object-cover"
                    alt="-"
                    unoptimized
                  />
                </dd>
              </div>
            </dl>
          </>
        )}

        {activeTab === 'thirdTab' && (
          <>
            <h6 className="text-2xl font-bold leading-snug text-label-normal">멋사 로켓단</h6>

            <div className="w-full bg-alternative px-6 py-5">
              <p className="text-base leading-normal text-label-neutral">
                프론트엔드, 백엔드 등 다양한 직무의 개발자들과 함께, 실무와 동일한 협업 환경에서
                6주간 UXUI 프로젝트를 <br />
                진행합니다.
              </p>
            </div>

            <dl className="flex flex-col gap-3">
              <dt className="text-base font-semibold text-label-normal">
                멋사 로켓단 프로젝트 사진
              </dt>
              <dd className="text-base leading-normal text-label-neutral">
                <Image
                  src="https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-design-5th/section4_img5_pc.png"
                  layout="fill"
                  objectFit="cover"
                  className="!relative z-10 w-full object-cover"
                  alt="-"
                />
              </dd>
            </dl>
          </>
        )}
      </div>
    </>
  )
}

export default InternshipTab
